import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ILMSModuleInfo} from "../constants/ILMS";
import {API, Endpoints} from "@brg/api";
import {IDiscipline, IDisciplineOption} from "../constants/courses/IDiscipline";
import {BASE_DISCIPLINE_COLOR} from "../constants/courseTypes";

interface LMSInitial {
    LMSModule: ILMSModuleInfo | null
    lmsDisciplines: {[key: string]: IDiscipline<'Global'>[]}
    lmsDisciplinesOptions: {[key: string]: IDisciplineOption<'Global'>[]}
    lmsDisciplinesColors: {[key: string]: {[key: string]: string}}
    lmsDisciplinesTeamId: string[],
    loading: boolean,
}

const initialState: LMSInitial = {
    LMSModule: null,
    lmsDisciplines: {},
    lmsDisciplinesOptions: {},
    lmsDisciplinesColors: {},
    lmsDisciplinesTeamId: [],
    loading: false,
}

export const loadLMSDisciplines = createAsyncThunk<any, {teamId: string}>(
    'lmsDisciplines/Load',
    async ({teamId}, thuncApi) => {
        try {
            const state = thuncApi.getState();
            // @ts-ignore
            if (teamId === '') {
                return thuncApi.rejectWithValue('No team id');
            }
            // @ts-ignore
            if ((state?.lms?.lmsDisciplinesTeamId || [])?.includes(teamId)) {
                return thuncApi.rejectWithValue('Disciplines already loaded');
            }

            // Set loading to true after checks are passed
            thuncApi.dispatch(setDisciplinesLoading(true));

            let disciplines = await API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetDisciplines')
                .get()
                .addQuery('teamId', teamId || '')
                .send()

            disciplines = await disciplines.json()
            return {
                disciplines,
                teamId
            }
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const LMSSlice = createSlice({
    name: 'lms',
    initialState,
    reducers: {
        addLMSDisciplinesTeamId: (state, action) => {
            if (!action.payload || state.lmsDisciplinesTeamId.includes(action.payload)) return;
            state.lmsDisciplinesTeamId = [...state.lmsDisciplinesTeamId, action.payload];
        },
        setLMSModule: (state, action) => {
            state.LMSModule = action.payload;
        },
        clearLMSModule: (state) => {
            state.LMSModule = null;
        },
        setDisciplinesLoading: (state, action) => {
            state.loading = action.payload
        }
    },
    extraReducers: {
        [loadLMSDisciplines.fulfilled.toString()]: (state, action) => {
            state.lmsDisciplines[action.payload.teamId] = action.payload.disciplines
            state.lmsDisciplinesOptions[action.payload.teamId] = (action.payload.disciplines?.length > 0 ? action.payload.disciplines : [{id: "", name: ""}]).map((i: any) => ({ value: i?.id, label: i?.name }))

            let result = {};
            (action.payload.disciplines || []).forEach((i: IDiscipline<'Global'>) => {
                // @ts-ignore
                result[i?.id] = i?.color
            })
            if (Object.keys(result).length === 0) result = {['base']: BASE_DISCIPLINE_COLOR}
            state.lmsDisciplinesColors[action.payload.teamId] = result
            state.loading = false
        },
        [loadLMSDisciplines.rejected.toString()]: (state, action) => {
            state.loading = false
        },
    },
});

export default LMSSlice

export const {
    setLMSModule,
    clearLMSModule,
    setDisciplinesLoading
} = LMSSlice.actions

export const LMSActions = LMSSlice.actions
export const selectorLMSModuleInfo = (state: any): ILMSModuleInfo | null => state.lms.LMSModule
export const selectorLMS = (state: any) => state.lmsimport {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ILMSModuleInfo} from "../constants/ILMS";
import {API, Endpoints} from "@brg/api";
import {IDiscipline, IDisciplineOption} from "../constants/courses/IDiscipline";
import {BASE_DISCIPLINE_COLOR} from "../constants/courseTypes";

interface LMSInitial {
    LMSModule: ILMSModuleInfo | null
    lmsDisciplines: {[key: string]: IDiscipline<'Global'>[]}
    lmsDisciplinesOptions: {[key: string]: IDisciplineOption<'Global'>[]}
    lmsDisciplinesColors: {[key: string]: {[key: string]: string}}
    lmsDisciplinesTeamId: string[],
    loading: boolean,
}

const initialState: LMSInitial = {
    LMSModule: null,
    lmsDisciplines: {},
    lmsDisciplinesOptions: {},
    lmsDisciplinesColors: {},
    lmsDisciplinesTeamId: [],
    loading: false,
}

export const loadLMSDisciplines = createAsyncThunk<any, {teamId: string}>(
    'lmsDisciplines/Load',
    async ({teamId}, thuncApi) => {
        try {
            const state = thuncApi.getState();
            // @ts-ignore
            if (teamId === '') {
                return thuncApi.rejectWithValue('No team id');
            }
            // @ts-ignore
            if ((state?.lms?.lmsDisciplinesTeamId || [])?.includes(teamId)) {
                return thuncApi.rejectWithValue('Disciplines already loaded');
            }

            // Set loading to true after checks are passed
            thuncApi.dispatch(setDisciplinesLoading(true));

            let disciplines = await API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetDisciplines')
                .get()
                .addQuery('teamId', teamId || '')
                .send()

            disciplines = await disciplines.json()
            return {
                disciplines,
                teamId
            }
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const LMSSlice = createSlice({
    name: 'lms',
    initialState,
    reducers: {
        addLMSDisciplinesTeamId: (state, action) => {
            if (!action.payload || state.lmsDisciplinesTeamId.includes(action.payload)) return;
            state.lmsDisciplinesTeamId = [...state.lmsDisciplinesTeamId, action.payload];
        },
        setLMSModule: (state, action) => {
            state.LMSModule = action.payload;
        },
        clearLMSModule: (state) => {
            state.LMSModule = null;
        },
        setDisciplinesLoading: (state, action) => {
            state.loading = action.payload
        }
    },
    extraReducers: {
        [loadLMSDisciplines.fulfilled.toString()]: (state, action) => {
            state.lmsDisciplines[action.payload.teamId] = action.payload.disciplines
            state.lmsDisciplinesOptions[action.payload.teamId] = (action.payload.disciplines?.length > 0 ? action.payload.disciplines : [{id: "", name: ""}]).map((i: any) => ({ value: i?.id, label: i?.name }))

            let result = {};
            (action.payload.disciplines || []).forEach((i: IDiscipline<'Global'>) => {
                // @ts-ignore
                result[i?.id] = i?.color
            })
            if (Object.keys(result).length === 0) result = {['base']: BASE_DISCIPLINE_COLOR}
            state.lmsDisciplinesColors[action.payload.teamId] = result
            state.loading = false
        },
        [loadLMSDisciplines.rejected.toString()]: (state, action) => {
            state.loading = false
        },
    },
});

export default LMSSlice

export const {
    setLMSModule,
    clearLMSModule,
    setDisciplinesLoading
} = LMSSlice.actions

export const LMSActions = LMSSlice.actions
export const selectorLMSModuleInfo = (state: any): ILMSModuleInfo | null => state.lms.LMSModule
export const selectorLMS = (state: any) => state.lms